import { Box, Grid, Button } from "@mui/material";
import React from "react";
import HorizontalBarChart from "Samarth Module/components/SamarthAi/Graphs/HorizontalBarChart";
import RefreshIcon from "../../../assets/images/refresh.svg";
import ChatIcon from "../../../assets/images/chat.svg";
import ExportIcon from "../../../assets/images/export.svg";
import ExpandIcon from "../../../assets/images/expandmore.svg";
import HeatmapTable from "Samarth Module/components/SamarthAi/Graphs/Heatmap";
import SemiCircleChart from "Samarth Module/components/SamarthAi/Graphs/SemiCircleChart";
import OrderOverviewTable from "Samarth Module/components/SamarthAi/GroupedTable";
import SamarthAIDrawer from "Samarth Module/components/SamarthAi/SamarthAIDrawer";
import VerticalBarChart from "Samarth Module/components/SamarthAi/Graphs/VerticalBarChart";
import PieChart from "Samarth Module/components/SamarthAi/Graphs/PieChart";
import ComposedChart from "Samarth Module/components/SamarthAi/Graphs/ComposedChart";
import MultiLineChart from "Samarth Module/components/SamarthAi/Graphs/MultiLineChart";
import TableIcon from "../../../assets/images/tableIcon.svg";
import GraphIcon from "../../../assets/images/graphIcon.svg";
import ExpandLessIcon from "../../../assets/images/expandless.svg";
const chatBtn = {
  background: 'linear-gradient(270.63deg, #FFEC9A -0.28%, #00B2FF 14.76%, #1F36C7 100%)',
  height: '40px',
  fontSize: '14px',
  color: '#FFFFFF',
  p: '0 16px',
  borderRadius: '32px'
}

export const lossByLossConfig = {
  title: "Loss by loss reasons",
  lastRefreshed: "",

  data: [
    { name: "UL", value: 140, percent: "36.6%" },
    { name: "SOL", value: 9, percent: "22.2%" },
    { name: "OCB", value: 56, percent: "10.1%" },
    { name: "FLL", value: 45, percent: "8.1%" },
    { name: "BS", value: 21, percent: "3.8%" },
  ],

  styles: {
    barColor: "#B6F7FF",
    valueColor: "#1A2025",
    smallBarColor: "#1A2025",
    percentColor: "#667F93",
  },
};

export const lossValidityConfig = {
  title: "Loss validity value(%)",
  lastRefreshed: "",

  data: [
    { name: "Day>7", value: 124, percent: "49.6%" },
    { name: "Day 4-7", value: 2, percent: "22.2%" },
    { name: "Day 2-3", value: 56, percent: "10.1%" },
    { name: "Day 1", value: 20, percent: "5.1%" },
    { name: "Day 0", value: 17, percent: "3.8%" },
  ],

  styles: {
    barColor: "#0066CC",
    valueColor: "#fff",
    smallBarColor: "#0066CC",
    percentColor: "#fff",
  },
};

export const heatmapConfig = {
  title: "Loss heat map - BG/Channel",
  lastRefreshed: "",
  rowHeaderTitle: "BG / Channel",

  columns: ["MT", "GT", "CSD", "OH", "RD"],

  data: [
    { channel: "Home care", MT: 21, GT: 0, CSD: 5, OH: 1, RD: 13 },
    { channel: "Personal care", MT: 12, GT: 23, CSD: 3, OH: 8, RD: 21 },
    { channel: "BWB", MT: 5, GT: 13, CSD: 7, OH: 1, RD: 9 },
    { channel: "Foods", MT: 3, GT: 23, CSD: 4, OH: 3, RD: 1 },
  ],

  getHeatColor: (value) => {
    if (value >= 20) return { bg: "#1F36C7B2", color: "#fff" };
    if (value >= 10) return { bg: "#8F9AE3", color: "#fff" };
    if (value >= 5) return { bg: "#8F9AE366", color: "#000" };
    return { bg: "#EEF2FF", color: "#000" };
  },
};

export const lossByReasonSemiCircleConfig = {
  title: "Loss by loss reasons",
  lastRefreshed: "",

  data: [
    { name: "Supply Led Losses", value: 56.5, unit: "T" },
    { name: "Master Led Losses", value: 29.2, unit: "T" },
    { name: "Customer Led Losses", value: 14.3, unit: "T" },
  ],

  styles: {
    colors: ["#C2E0FF", "#60A5FA", "#E7DCF9", "#245698"],
  },
};

export const headerConfig = [
  {
    cells: [
      { label: "Format", rowSpan: 2, width: 110 },
      { label: "Base pack", rowSpan: 2, width: 80 },
      { label: "Basepack desc", rowSpan: 2, width: 150 },
      { label: "Depot", rowSpan: 2, width: 75 },
      { label: "Material", rowSpan: 2, width: 90 },
      { label: "Order details", colSpan: 3, group: "mid" },
      { label: "Order Loss Details", colSpan: 4, group: "light" },
      { label: "Order Date", rowSpan: 2, width: 100 },
      { label: "Order Validity", rowSpan: 2, width: 110 },
    ],
  },
  {
    cells: [
      { label: "Allocation", parent: "mid", width: 90 },
      { label: "Delivery", parent: "mid", width: 90 },
      { label: "Invoiced", parent: "mid", width: 90 },

      { label: "Allocation to Delivery loss", parent: "light", width: 160 },
      { label: "Supply led loss", parent: "light", width: 110 },
      { label: "Freshness led Loss", parent: "light", width: 120 },
      { label: "Loss Bucket", parent: "light", width: 145 },
    ],
  },
];
export const tableHeaderConfig = [
  {
    cells: [
      { label: "Product Type", rowSpan: 2, width: 130 },
      { label: "SKU Code", rowSpan: 2, width: 100 },
      { label: "Location", rowSpan: 2, width: 100 },
      { label: "Sales Summary", colSpan: 3, group: "mid" },
      { label: "Loss Details", colSpan: 2, group: "light" },
      { label: "Created On", rowSpan: 2, width: 110 },
    ],
  },
  {
    cells: [
      { label: "Target", parent: "mid", width: 90 },
      { label: "Achieved", parent: "mid", width: 90 },
      { label: "Billed", parent: "mid", width: 90 },

      { label: "Stock Loss", parent: "light", width: 120 },
      { label: "Damage Loss", parent: "light", width: 120 },
    ],
  },
];
export const tableRowData = [
  {
    id: 1,
    cells: [
      { value: "Shower Gel" },
      { value: "SG1001" },
      { value: "Bangalore" },
      { value: 500 },
      { value: 470 },
      { value: 470 },
      { value: 30 },
      { value: 0 },
      { value: "12/02/26" },
    ],
  },
  {
    id: 2,
    cells: [
      { value: "Face Cream" },
      { value: "FC2002" },
      { value: "Hyderabad" },
      { value: 300 },
      { value: 250 },
      { value: 250 },
      { value: 40 },
      { value: 10 },
      { value: "18/02/26" },
    ],
  },
];
export const rows = [
  {
    format: "Body wash",
    basePack: 17239,
    basePackDesc: "LUX BW French",
    depot: "PATH",
    material: "PSH0100",
    allocation: 444,
    delivery: 432,
    invoiced: 432,
    allocationToDeliveryLoss: 12,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Delivery Zeroised",
    orderDate: "16/08/25",
    orderValidity: "05/10/25",
  },
  {
    format: "Moisturizer tu...",
    basePack: 10293,
    basePackDesc: "Ultra Hydratın...",
    depot: "CHKH",
    material: "DVSV1R3",
    allocation: 24,
    delivery: 8,
    invoiced: 8,
    allocationToDeliveryLoss: 16,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Freshness Led Loss",
    orderDate: "08/09/25",
    orderValidity: "19/10/25",
  },
  {
    format: "CS pouch",
    basePack: 10111,
    basePackDesc: "Revitalizing Fa...",
    depot: "PATH",
    material: "VICY1R2",
    allocation: 20,
    delivery: 10,
    invoiced: 10,
    allocationToDeliveryLoss: 10,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Freshness Led Loss",
    orderDate: "18/09/25",
    orderValidity: "23/10/25",
  },
  {
    format: "Pw Cartons",
    basePack: 12137,
    basePackDesc: "Soothing Aloe...",
    depot: "PATH",
    material: "PMMD1R2",
    allocation: 96,
    delivery: 72,
    invoiced: 72,
    allocationToDeliveryLoss: 24,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Freshness Led Loss",
    orderDate: "11/09/25",
    orderValidity: "29/10/25",
  },
  {
    format: "Wash liquid",
    basePack: 19202,
    basePackDesc: "Nourishing Ha...",
    depot: "CHKH",
    material: "RSAZ1R4",
    allocation: 1240,
    delivery: 250,
    invoiced: 250,
    allocationToDeliveryLoss: 990,
    supplyLedLoss: 990,
    freshnessLedLoss: 0,
    lossBucket: "Unaccounted",
    orderDate: "28/09/25",
    orderValidity: "03/11/25",
  },
  {
    format: "Vim liquid",
    basePack: 12139,
    basePackDesc: "Exfoliating Scr...",
    depot: "PATH",
    material: "EAMA1R2",
    allocation: 222,
    delivery: 48,
    invoiced: 48,
    allocationToDeliveryLoss: 174,
    supplyLedLoss: 174,
    freshnessLedLoss: 0,
    lossBucket: "Unaccounted",
    orderDate: "28/09/25",
    orderValidity: "03/11/25",
  },
  {
    format: "NMB",
    basePack: 12139,
    basePackDesc: "Deep Cleansi...",
    depot: "CHKH",
    material: "LCRN1R1",
    allocation: 72,
    delivery: 24,
    invoiced: 24,
    allocationToDeliveryLoss: 48,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Delivery Zeroised",
    orderDate: "07/08/25",
    orderValidity: "30/09/25",
  },
  {
    format: "NMB",
    basePack: 12139,
    basePackDesc: "Anti-Aging Ni...",
    depot: "CHKH",
    material: "RPYF2R5",
    allocation: 400,
    delivery: 24,
    invoiced: 200,
    allocationToDeliveryLoss: 200,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Unaccounted",
    orderDate: "22/09/25",
    orderValidity: "29/09/25",
  },
  {
    format: "NMB",
    basePack: 12139,
    basePackDesc: "Refreshing Mis...",
    depot: "CHKH",
    material: "NMAC2RO",
    allocation: 960,
    delivery: 840,
    invoiced: 840,
    allocationToDeliveryLoss: 120,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Unaccounted",
    orderDate: "25/09/25",
    orderValidity: "30/09/25",
  },
  {
    format: "Body wash",
    basePack: 17241,
    basePackDesc: "LUX BW Rose...",
    depot: "PATH",
    material: "PSH0200",
    allocation: 320,
    delivery: 300,
    invoiced: 300,
    allocationToDeliveryLoss: 20,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Delivery Zeroised",
    orderDate: "20/08/25",
    orderValidity: "10/10/25",
  },
  {
    format: "Shampoo",
    basePack: 13450,
    basePackDesc: "Silk Smooth Sh...",
    depot: "CHKH",
    material: "SHM0101",
    allocation: 500,
    delivery: 480,
    invoiced: 480,
    allocationToDeliveryLoss: 20,
    supplyLedLoss: 0,
    freshnessLedLoss: 20,
    lossBucket: "Freshness Led Loss",
    orderDate: "01/10/25",
    orderValidity: "15/11/25",
  },
  {
    format: "Conditioner",
    basePack: 14120,
    basePackDesc: "Repair & Resto...",
    depot: "PATH",
    material: "CON0303",
    allocation: 180,
    delivery: 160,
    invoiced: 160,
    allocationToDeliveryLoss: 20,
    supplyLedLoss: 0,
    freshnessLedLoss: 0,
    lossBucket: "Unaccounted",
    orderDate: "05/10/25",
    orderValidity: "20/11/25",
  },
];
const leafColumns = [
  "format",
  "basePack",
  "basePackDesc",
  "depot",
  "material",
  "allocation",
  "delivery",
  "invoiced",
  "allocationToDeliveryLoss",
  "supplyLedLoss",
  "freshnessLedLoss",
  "lossBucket",
  "orderDate",
  "orderValidity",
];

const tableRows = rows.map((row, i) => ({
  id: i,
  cells: leafColumns.map((key, ci) => ({
    value: row[key] ?? "-",
  })),
}));
export const totals = {
  allocation: 468,
  delivery: 440,
  invoiced: 440,
  allocationToDeliveryLoss: 28,
  supplyLedLoss: 0,
  freshnessLedLoss: 0,
};

export const colors = {
  headerDark: "#354ACD",
  headerMid: "#C2E0FF",
  headerLight: "#354ACD",

  borderDark: "#D9E1E7",
  borderMid: "#4D5F6E",
  borderLight: "#D9E1E7",

  textDark: "#fff",
  textMid: "#1A2025",
  textLight: "#fff",
};

const verticalChartdata = [
  { name: "Jan", value: 400, percent: "20%" },
  { name: "Feb", value: 300, percent: "15%" },
  { name: "Mar", value: 500, percent: "25%" },
  { name: "Apr", value: 700, percent: "35%" },
];

const pieChartdata = [
  { name: "Brand A", value: 910000 },
  { name: "Brand B", value: 175000 },
  { name: "Brand C", value: 132000 },
  { name: "Brand D", value: 98000 },
];

const ComposedChartData = [
  { name: "Jan", sales: 400, profit: 240, revenue: 500 },
  { name: "Feb", sales: 300, profit: 139, revenue: 450 },
  { name: "Mar", sales: 500, profit: 300, revenue: 650 },
  { name: "Apr", sales: 700, profit: 400, revenue: 900 },
  { name: "May", sales: 600, profit: 350, revenue: 800 },
];
export const multiLineChartConfig = {
  title: "Performance Trend",
  refreshTime: "Updated 2 mins ago",

  chartData: [
    { date: "01 Jan", mtDay0Dash: 42, mtDay2: 32, mtDay0: 22, gtDay0: 12 },
    { date: "02 Jan", mtDay0Dash: 38, mtDay2: 28, mtDay0: 25, gtDay0: 15 },
    { date: "03 Jan", mtDay0Dash: 45, mtDay2: 35, mtDay0: 30, gtDay0: 18 },
    { date: "04 Jan", mtDay0Dash: 50, mtDay2: 40, mtDay0: 28, gtDay0: 20 },
    { date: "05 Jan", mtDay0Dash: 48, mtDay2: 38, mtDay0: 26, gtDay0: 19 },
    { date: "06 Jan", mtDay0Dash: 52, mtDay2: 42, mtDay0: 32, gtDay0: 22 },
    { date: "07 Jan", mtDay0Dash: 55, mtDay2: 45, mtDay0: 35, gtDay0: 25 },
    { date: "01 Jan", mtDay0Dash: 42, mtDay2: 32, mtDay0: 22, gtDay0: 12 },
    { date: "02 Jan", mtDay0Dash: 38, mtDay2: 28, mtDay0: 25, gtDay0: 15 },
    { date: "03 Jan", mtDay0Dash: 45, mtDay2: 35, mtDay0: 30, gtDay0: 18 },
    { date: "04 Jan", mtDay0Dash: 50, mtDay2: 40, mtDay0: 28, gtDay0: 20 },
    { date: "05 Jan", mtDay0Dash: 48, mtDay2: 38, mtDay0: 26, gtDay0: 19 },
    { date: "06 Jan", mtDay0Dash: 52, mtDay2: 42, mtDay0: 32, gtDay0: 22 },
    { date: "07 Jan", mtDay0Dash: 55, mtDay2: 45, mtDay0: 35, gtDay0: 25 },
  ],

  yLabels: {
    20: "GT - Day 0",
    40: "MT - Day 0",
    60: "MT - Day 2",
    80: "MT - Day 0",
  },

  lines: [
    { dataKey: "mtDay0Dash", color: "#B69CFF", dashed: true },
    { dataKey: "mtDay2", color: "#6C3BFF" },
    { dataKey: "mtDay0", color: "#BFA8F5" },
    { dataKey: "gtDay0", color: "#FF4DA6" },
  ],

  legendItems: [
    { color: "#B69CFF", label: "MT - Day 0 (Dash)", dashed: true },
    { color: "#6C3BFF", label: "MT - Day 2" },
    { color: "#BFA8F5", label: "MT - Day 0" },
    { color: "#FF4DA6", label: "Day 0 - GT" },
  ],
};

export default function Graphs() {
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const handleOpenDrawer = () => setOpenDrawer(true);
  const handleCloseDrawer = () => setOpenDrawer(false);
  const handleRefresh = () => {
    console.log("refresh clicked");
  };

  return (
    <Box
      p={2}
      pb={8}
      sx={{ height: "calc(100vh - 79px)", overflowY: "auto" }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Button sx={chatBtn} onClick={handleOpenDrawer}>
            Ask Samarth AI
          </Button>
          <SamarthAIDrawer
            drawer
            open={openDrawer}
            onClose={handleCloseDrawer}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <HorizontalBarChart
            title={lossByLossConfig.title}
            lastRefreshed={lossByLossConfig.lastRefreshed}
            data={lossByLossConfig.data}
            {...lossByLossConfig.styles}
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={[
              "Executive Overview",
              "Sales Performance",
              "Marketing Analytics",
              "Finance Summary",
              "Customer Insights",
              "Operations Dashboard",
              "Product Metrics",
              "Revenue Tracking",
              "HR Analytics",
              "Inventory Management",
              "Campaign Performance",
              "Regional Performance",
            ]}
            showRefresh={false}
            showChat={false}
            headerConfig={tableHeaderConfig}
            rows={tableRowData}
            colors={colors}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <HorizontalBarChart
            title={lossValidityConfig.title}
            lastRefreshed={lossValidityConfig.lastRefreshed}
            data={lossValidityConfig.data}
            {...lossValidityConfig.styles}
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={[
              "Business Health Monitor",
              "Growth Insights",
              "KPI Tracker",
              "Profit & Loss Overview",
              "User Engagement Metrics",
              "Conversion Analytics",
              "Supply Chain Overview",
              "Risk & Compliance Dashboard",
              "Performance Benchmarking",
              "Strategic Planning Board",
              "Real-Time Monitoring",
              "Data Intelligence Hub",
            ]}
            showRefresh={false}
            showChat={false}
            headerConfig={headerConfig}
            rows={tableRows}
            colors={colors}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <HeatmapTable
            title={heatmapConfig.title}
            lastRefreshed={heatmapConfig.lastRefreshed}
            data={heatmapConfig.data}
            columns={heatmapConfig.columns}
            getStyles={heatmapConfig.getHeatColor}
            rowHeaderTitle={heatmapConfig.rowHeaderTitle}
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={["Retail", "Corporate", "SME", "Wealth"]}
            showRefresh={false}
            showChat={false}
            headerConfig={tableHeaderConfig}
            rows={tableRowData}
            color={colors}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SemiCircleChart
            title={lossByReasonSemiCircleConfig.title}
            lastRefreshed={lossByReasonSemiCircleConfig.lastRefreshed}
            data={lossByReasonSemiCircleConfig.data}
            colors={lossByReasonSemiCircleConfig.styles.colors}
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={["Retail", "Corporate", "SME", "Wealth"]}
            showRefresh={false}
            showChat={false}
            headerConfig={tableHeaderConfig}
            rows={tableRowData}
            color={colors}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <VerticalBarChart
            title="Monthly Sales"
            data={verticalChartdata}
            lastRefreshed=""
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={["Retail", "Corporate", "SME", "Wealth"]}
            showRefresh={false}
            showChat={false}
            headerConfig={headerConfig}
            rows={tableRows}
            colors={colors}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <PieChart
            title="Brand-Level"
            data={pieChartdata}
            lastRefreshed=""
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={["Retail", "Corporate", "SME", "Wealth"]}
            showRefresh={false}
            showChat={false}
            headerConfig={tableHeaderConfig}
            rows={tableRowData}
            color={colors}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ComposedChart
            title="Sales Performance"
            data={ComposedChartData}
            lastRefreshed=""
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={["Retail", "Corporate", "SME", "Wealth"]}
            showRefresh={true}
            showChat={false}
            headerConfig={tableHeaderConfig}
            rows={tableRowData}
            color={colors}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MultiLineChart
            title={multiLineChartConfig.title}
            refreshTime={multiLineChartConfig.refreshTime}
            chartData={multiLineChartConfig.chartData}
            yLabels={multiLineChartConfig.yLabels}
            lines={multiLineChartConfig.lines}
            legendItems={multiLineChartConfig.legendItems}
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={["Retail", "Corporate", "SME", "Wealth"]}
            showRefresh={false}
            showChat={false}
            onRefresh={() => console.log("refresh")}
            headerConfig={tableHeaderConfig}
            rows={tableRowData}
            color={colors}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <OrderOverviewTable
            title="Order Overview"
            refreshTime="Updated 2 mins ago"
            headerConfig={headerConfig}
            rows={tableRows}
            // totals={totals}
            colors={colors}
            icons={{
              refresh: RefreshIcon,
              chat: ChatIcon,
              export: ExportIcon,
              expand: ExpandIcon,
              table: TableIcon,
              graph: GraphIcon,
              expandless: ExpandLessIcon,
            }}
            dashboardData={["Retail", "Corporate", "SME", "Wealth"]}
            showRefresh={false}
            showChat={false}
            onRefresh={handleRefresh}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
